import React from 'react';
import PropTypes from 'prop-types';
import LoadingSpinner from 'components/LoadingSpinner';
import { Message } from 'components/shared';
import Grid from '@material-ui/core/Grid';
import PerformanceCell from './components/PerformanceCell';

const PerformanceWidget = ({ state }) => {
  const { isLoading, isError, error, data } = state;
  if (isError) {
    return <Message type="error" text={error} />;
  }

  if (isLoading || !data) {
    return <LoadingSpinner />;
  }

  return (
    <Grid container direction="row-reverse" alignItems="center" justify="center">
      {data &&
        data.data.length > 0 &&
        data.data.map(value => (
          <Grid item xs={4} key={value.text} style={{ padding: '4px' }}>
            <PerformanceCell {...value} />
          </Grid>
        ))}
    </Grid>
  );
};
PerformanceWidget.propTypes = {
  state: PropTypes.shape({
    isLoading: PropTypes.bool,
    isError: PropTypes.bool,
    error: PropTypes.string,
    data: PropTypes.shape({
      data: PropTypes.arrayOf(
        PropTypes.shape({
          text: PropTypes.string,
          value: PropTypes.number
        })
      )
    })
  }).isRequired
};

export default PerformanceWidget;
